import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const QuestionHeader = ({
  title,
  note,
  description,
  skipTopMargin = false,
}) => (
  <React.Fragment>
    {title && (
      <h4
        className={classNames(
          'text-size-h4',
          'color-grey-10',
          'display-block',
          'fw-400',
          { 'margin-top-lg': !skipTopMargin },
          'margin-btm-xs',
        )}
      >
        {title}
      </h4>
    )}
    {note && (
      <h4
        className="padding-horizontal-xxs padding-vertical-tiny text-size-h5 display-inline-block"
        style={{
          color: '#79A6A9',
          backgroundColor: '#cceaeda1',
          borderRadius: '2px',
        }}
      >
        {note}
      </h4>
    )}
    {description && (
      <p className="margin-none padding-horizontal-xxs padding-btm-xxs text-size-h5 display-inline-block text-wrap-pre-wrap">
        {description}
      </p>
    )}
  </React.Fragment>
);

QuestionHeader.propTypes = {
  title: PropTypes.string,
  note: PropTypes.string,
  description: PropTypes.string,
  skipTopMargin: PropTypes.bool,
};

export default QuestionHeader;
